
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1024","height":"1024","viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#e6b91e","d":"M.008-.008h1024.293v1024.292H.008z"}}),_c('path',{attrs:{"d":"M106.5 346.2c-.3.7-.4 74.6-.3 164.3l.3 163 42.3.3 42.2.2V345h-42c-32.7 0-42.2.3-42.5 1.2zM220 509.5V674l37.3-.2 37.2-.3.5-103.9.5-103.8 14.9 103.3c8.2 56.9 15.1 103.7 15.3 104.1.2.5 12.3.8 26.7.8h26.3l.5-3.3c.3-1.7 6.8-50 14.4-107.2l13.9-104 .3 107.3.2 107.2 37.3-.2 37.2-.3v-328l-54.9-.3c-30.3-.1-55.3.1-55.7.5-.3.5-4.9 34-10 74.6-5.2 40.5-9.7 72.9-10.1 72-.4-1-4.3-27.5-8.8-58.8-8.3-58.9-11.7-82.4-12.6-86.3l-.4-2.2H220v164.5zm291 0V674h53.8c78 0 93.7-1.3 109.8-9 13.9-6.7 22.5-18.1 25.8-34.2 2.8-13.7 3.6-37 3.6-113.8 0-78-.9-106.6-3.5-119.4-4.5-21.6-19.1-37.5-41.5-45-16.4-5.4-47.4-7.5-111.7-7.6H511v164.5zm102.8-104.8c2.4 1.2 4.4 3.2 5.7 5.8 2 3.9 2 6 2 96 0 85-.1 92.4-1.8 97.7-2.5 8.3-6.6 10.9-18.9 12.1l-4.8.5V401.7l7.1.6c3.8.3 8.7 1.4 10.7 2.4zM732 509.5V674h76.9l1.1-4c.5-2.2 1.5-5.9 2.1-8.3 2.1-8.6 1.6-8.4 7.3-2.9 11 10.7 21 15.9 35.6 18.2 20.9 3.3 40.3-2.3 53.4-15.4 11.9-11.9 14.1-19.1 15.7-53.1 1.4-28.2.5-133-1.2-142-4.5-23.9-24.4-37.5-55-37.5-21.1 0-34.8 4.7-47.4 16.2l-6.5 6V345h-82v164.5zm102.7-30.8c7 3.3 6.8 1.2 6.8 73.8 0 35.7-.4 66.7-.8 68.8-1.9 9-19 11.7-23.2 3.6-3-5.7-3.7-22.8-3.2-80.8.4-59.5.6-62.5 5-65.6 2.9-2 11-1.9 15.4.2z"}}),_c('path',{attrs:{"fill":"none","d":"M239.314 52.939h187.155v121.19H239.314z"}})])
          )
        }
      }
    